@if (enableLeaveOfAbsenceTool) {
    <div class="loa-tool">
        <ng-template #loading>
            <div class="page-loader text-center">
                <div class="loader"></div>
            </div>
        </ng-template>

        <!-- Introduction -->
        @if (!quizHasStarted) {
            <div [innerHTML]="block.data.text"></div>
            <button class="btn btn-primary" (click)="startQuiz()">{{ 'Start' | translate }}</button>
        }

        <!-- Initial question to determine chosen leaving reason -->
        @if (chosenReason === '' && quizHasStarted) {
            <section>
                <h2 class="loa-tool__question-heading" [innerText]="leaveReasonQuestion.questionText"></h2>
                <div class="loa-tool__questions">
                    @for (leaveAnswer of leaveReasonQuestion.answers; track leaveAnswer.value) {
                        <label class="loa-tool__question-option">
                            <input
                                type="radio"
                                name="radio-leave-reason"
                                value="{{ leaveAnswer.value }}"
                                (change)="selectedRadioOption = leaveAnswer.value" />
                            <span [innerText]="leaveAnswer.description"></span>
                        </label>
                    }
                </div>
                <div class="loa-tool__buttons loa-tool__buttons--single">
                    <button
                        class="btn btn-primary"
                        (click)="chooseLeaveReason(selectedRadioOption)"
                        [disabled]="selectedRadioOption === ''">
                        {{ 'Next' | translate }}
                    </button>
                </div>
            </section>
        }

        <!-- Bulk question and answer section -->
        @if (questionsForChosenReason !== undefined && quizHasStarted) {
            <div>
                @if (!quizIsComplete) {
                    @if (breadcrumbValues.length > 0) {
                        <ol class="loa-tool-results-breadcrumb">
                            @for (breadcrumb of breadcrumbValues; track breadcrumb) {
                                <li class="loa-tool-results-breadcrumb__item">
                                    <img src="/assets/img/ui/timeline-breadcrumb-tick.svg" alt="" />
                                    <span class="loa-tool-results-breadcrumb__text" [innerText]="breadcrumb"></span>
                                </li>
                            }
                        </ol>
                    }
                }
                <!-- Questions -->
                @if (answersArrayLength < questionsForChosenReason.length) {
                    <section>
                        @for (question of questionsForChosenReason; track question.questionName; let i = $index) {
                            <div>
                                @if (i === answersArrayLength) {
                                    <div>
                                        <div class="loa-tool__question-number">
                                            {{ 'Question' | translate }} {{ i + 1 }} {{ 'of' | translate }}
                                            {{ questionsForChosenReason.length }}
                                        </div>
                                        <h2 class="loa-tool__question-heading">{{ question.questionText }}</h2>
                                        @if (question.questionName === 'whoHasPassedAway') {
                                            <div class="mb-4">
                                                <p class="mb-0">
                                                    <small>{{
                                                        'Tier 1 includes: Parent (step), spouse (domestic partner), child (step), sibling (step), miscarriage or stillbirth'
                                                            | translate
                                                    }}</small>
                                                </p>
                                                <p class="mb-0">
                                                    <small>{{
                                                        'Tier 2 includes: Parent-in-law, child-in-law, sibling-in-law, grandparent, grandchild'
                                                            | translate
                                                    }}</small>
                                                </p>
                                                <p class="mb-0">
                                                    <small>{{
                                                        'Tier 3 includes: Grand-in-law, great grand (parent or child), aunt, uncle, veteran/reservist'
                                                            | translate
                                                    }}</small>
                                                </p>
                                                <p class="mb-0">
                                                    <small>{{
                                                        'Other: person is not listed in the above' | translate
                                                    }}</small>
                                                </p>
                                            </div>
                                        }
                                        <div class="loa-tool__questions">
                                            @for (questionOption of question.answers; track questionOption.value) {
                                                <label class="loa-tool__question-option">
                                                    <input
                                                        type="radio"
                                                        name="radio-{{ question.questionName }}"
                                                        value="{{ questionOption.value }}"
                                                        (change)="selectedRadioOption = questionOption.value" />
                                                    <span [innerText]="questionOption.description"></span><br />
                                                </label>
                                            }
                                        </div>
                                        <div class="loa-tool__buttons">
                                            <button class="btn btn-back" (click)="removeLastSelectedOption()">
                                                {{ 'Back' | translate }}
                                            </button>
                                            <button
                                                class="btn btn-primary"
                                                (click)="addSelectedOption(question.questionName, selectedRadioOption)"
                                                [disabled]="selectedRadioOption === ''">
                                                {{ 'Next' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </section>
                }

                <!-- Results -->
                @if (quizIsComplete) {
                    <div>
                        @if (breadcrumbValues.length > 0) {
                            <ol class="loa-tool-results-breadcrumb">
                                @for (breadcrumb of breadcrumbValues; track breadcrumb) {
                                    <li class="loa-tool-results-breadcrumb__item">
                                        <img src="/assets/img/ui/timeline-breadcrumb-tick.svg" alt="" />
                                        <span class="loa-tool-results-breadcrumb__text" [innerText]="breadcrumb"></span>
                                    </li>
                                }
                            </ol>
                        }
                        @switch (chosenReason) {
                            @case ('birth') {
                                <core-giving-birth-results
                                    [selectedAnswers]="selectedAnswers"
                                    [parentBlock]="block"
                                    [birthTimelineChartKey]="birthTimelineChartKey"></core-giving-birth-results>
                            }
                            @case ('sicknessOrInjury') {
                                <core-sick-or-injured-results
                                    [selectedAnswers]="selectedAnswers"
                                    [parentBlock]="block"
                                    [sicknessOrInjuryTimelineChartKey]="
                                        sicknessOrInjuryTimelineChartKey
                                    "></core-sick-or-injured-results>
                            }
                            @case ('surgery') {
                                <core-surgery-results
                                    [selectedAnswers]="selectedAnswers"
                                    [parentBlock]="block"
                                    [surgeryTimelineChartKey]="surgeryTimelineChartKey"></core-surgery-results>
                            }
                            @case ('bondingOnly') {
                                <core-bonding-results
                                    [selectedAnswers]="selectedAnswers"
                                    [parentBlock]="block"
                                    [bondingTimelineChartKey]="bondingTimelineChartKey"></core-bonding-results>
                            }
                            @case ('fmlaOnly') {
                                <core-fmla-only-results
                                    [selectedAnswers]="selectedAnswers"
                                    [parentBlock]="block"></core-fmla-only-results>
                            }
                            @case ('bereavement') {
                                <core-bereavement-results
                                    [selectedAnswers]="selectedAnswers"
                                    [parentBlock]="block"></core-bereavement-results>
                            }
                        }
                        <button class="btn btn-primary" (click)="startOver()">{{ 'Start over' | translate }}</button>
                    </div>
                }
            </div>
        }
    </div>
}
